import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { catchError, map, tap } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import _ from 'lodash';

export class NetzTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<any> {
    const lookUpUrl = this.environmentService.apiUrl + `lookup_properties/${lang}`;

    return forkJoin([
      this.http.get(`assets-base/i18n/locale-${lang}.json`),
      this.http.get(`assets/i18n/locale-${lang}.json`),
      this.http.get(lookUpUrl).pipe(
        map(response => response),
        catchError(() => of({}))
      ),
    ]).pipe(
      map((response: any) => {
        const mergedTranslations = _.merge(response[0], response[1]);
        return [mergedTranslations, response[2]];
      })
    );
  }
}
